import { render, staticRenderFns } from "./gSendCode.vue?vue&type=template&id=52d8803e&scoped=true"
import script from "./gSendCode.vue?vue&type=script&lang=js"
export * from "./gSendCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8803e",
  null
  
)

export default component.exports